import { Box, Icon } from '@chakra-ui/react';
import { Astronaut, ConnectWalletButton, CopyAddressButton, SimpleDisplayModalContent, SimpleModalHead, SimpleModalView } from '@cosmology-ui/react';
import React, { useCallback } from 'react';
import { RiDoorOpenFill } from 'react-icons/ri';
export const ConnectedView = ({
  onClose,
  onReturn,
  wallet
}) => {
  const {
    walletInfo: {
      prettyName,
      logo
    },
    username,
    address
  } = wallet;
  const onDisconnect = useCallback(() => {
    wallet.disconnect(true);
  }, [wallet]);
  const modalHead = /*#__PURE__*/React.createElement(SimpleModalHead, {
    title: prettyName,
    backButton: true,
    onClose: onClose,
    onBack: onReturn
  });
  const modalContent = /*#__PURE__*/React.createElement(SimpleDisplayModalContent, {
    logo: Astronaut,
    username: username,
    walletIcon: logo,
    addressButton: /*#__PURE__*/React.createElement(CopyAddressButton, {
      address: address
    }),
    bottomButton: /*#__PURE__*/React.createElement(Box, {
      px: 6
    }, /*#__PURE__*/React.createElement(ConnectWalletButton, {
      leftIcon: /*#__PURE__*/React.createElement(Icon, {
        as: RiDoorOpenFill
      }),
      buttonText: 'Disconnect',
      onClick: onDisconnect
    }))
  });
  return /*#__PURE__*/React.createElement(SimpleModalView, {
    modalHead: modalHead,
    modalContent: modalContent
  });
};